import React from "react";
import styled from "styled-components";

export const GradientBackground = ({ variant = "top" }) => {
  const variantColors = {
    top: {
      color1: "#02FE85",
      color2: "#4A25D5",
    },
    footer: {
      color1: "#00a3cc",
      color2: "#141623",
    },
  };

  return (
    <AnimatedBackground $isFooter={variant === "footer"}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1920 999"
        className="animated-svg"
        width="100%"
        height="120vh"
      >
        <defs>
          <filter id="heavy-blur" x="-50%" y="-50%" width="200%" height="200%">
            <feGaussianBlur
              in="SourceGraphic"
              stdDeviation="80"
              result="blur"
            />
            <feColorMatrix in="blur" type="saturate" values="1.5" />
          </filter>

          <filter id="glow" x="-50%" y="-50%" width="200%" height="200%">
            <feGaussianBlur in="SourceGraphic" stdDeviation="60" />
            <feColorMatrix
              type="matrix"
              values="
                1 0 0 0 0
                0 1 0 0 0
                0 0 1 0 0
                0 0 0 30 -15"
            />
          </filter>
          <linearGradient
            id="background-gradient"
            x1="0%"
            y1="0%"
            x2="0%"
            y2="100%"
          >
            <stop offset="0%" stopColor="#FFFFFF" />
            <stop offset="100%" stopColor="#D1C7F5" />
          </linearGradient>
        </defs>

        <style type="text/css">
          {`
              @keyframes morphGreen {
                0% { transform: scale(1) translate(0, 0); }
                25% { transform: scale(1.1) translate(-50px, 30px); }
                50% { transform: scale(0.95) translate(30px, -40px); }
                75% { transform: scale(1.05) translate(-20px, -20px); }
                100% { transform: scale(1) translate(0, 0); }
              }
              @keyframes morphPurple {
                0% { transform: scale(1) translate(0, 0); }
                33% { transform: scale(1.15) translate(40px, -30px); }
                66% { transform: scale(0.9) translate(-30px, 50px); }
                100% { transform: scale(1) translate(0, 0); }
              }
              .abstract-green {
                animation: morphGreen 10s ease-in-out infinite;
                mix-blend-mode: screen;
              }
              .abstract-purple {
                animation: morphPurple 10s ease-in-out infinite;
                mix-blend-mode: screen;
              }
            `}
        </style>

        <g className="abstract-green" filter="url(#heavy-blur)">
          <path
            d="M314.269 780.141C480.508 646.087 574.835 601.882 799.125 663.296C923.415 724.711 959.71 859.571 888.641 1003.4C853.423 1074.67 693.746 1202.27 590.011 1256.36C484.411 1311.43 424.581 1208.07 361.882 1177.09C237.593 1115.67 248.03 914.195 314.269 780.141Z"
            fill={variantColors[variant].color1}
            opacity="0.7"
          >
            <animate
              attributeName="d"
              dur="25s"
              repeatCount="indefinite"
              values="M314.269 780.141C480.508 646.087 574.835 601.882 799.125 663.296C923.415 724.711 959.71 859.571 888.641 1003.4C853.423 1074.67 693.746 1202.27 590.011 1256.36C484.411 1311.43 424.581 1208.07 361.882 1177.09C237.593 1115.67 248.03 914.195 314.269 780.141Z;
                       M374.41 783.225C505.023 600.243 757.285 519.863 911.441 596.035C1065.6 672.207 1182.35 855.528 1086.86 1048.78C1039.54 1144.55 946.72 1350.67 813.74 1426.52C678.361 1503.73 602.48 1353.13 524.716 1314.71C370.561 1238.54 223.103 995.2 374.41 783.225Z;
                       M314.269 780.141C480.508 646.087 574.835 601.882 799.125 663.296C923.415 724.711 959.71 859.571 888.641 1003.4C853.423 1074.67 693.746 1202.27 590.011 1256.36C484.411 1311.43 424.581 1208.07 361.882 1177.09C237.593 1115.67 248.03 914.195 314.269 780.141Z"
            />
          </path>
          <circle
            cx="500"
            cy="900"
            r="300"
            fill={variantColors[variant].color1}
            opacity="0.5"
            filter="url(#glow)"
          >
            <animate
              attributeName="r"
              dur="15s"
              repeatCount="indefinite"
              values="300;400;300"
            />
          </circle>
        </g>

        <g className="abstract-purple" filter="url(#heavy-blur)">
          <path
            d="M1126.64 574.387C1304.79 595.06 1436.75 766.047 1420.77 903.758C1404.79 1041.47 1311.71 1213.82 1120.57 1191.64C1025.85 1180.65 900.157 1259.36 795.581 1177.73C689.125 1094.62 736.968 909.826 745.03 840.357C761.01 702.646 948.492 553.715 1126.64 574.387Z"
            fill={variantColors[variant].color2}
            opacity="0.7"
          >
            <animate
              attributeName="d"
              dur="20s"
              repeatCount="indefinite"
              values="M1126.64 574.387C1304.79 595.06 1436.75 766.047 1420.77 903.758C1404.79 1041.47 1311.71 1213.82 1120.57 1191.64C1025.85 1180.65 900.157 1259.36 795.581 1177.73C689.125 1094.62 736.968 909.826 745.03 840.357C761.01 702.646 948.492 553.715 1126.64 574.387Z;
                       M1151.64 606.759C1411.87 673.236 1608.91 887.931 1589.09 1058.73C1569.27 1229.53 1413.65 1398.61 1156.83 1368.81C1029.56 1354.04 844.354 1521.21 703.019 1418.61C559.144 1314.16 621.176 1085.27 631.174 999.111C650.993 828.309 850.167 529.749 1151.64 606.759Z;
                       M1126.64 574.387C1304.79 595.06 1436.75 766.047 1420.77 903.758C1404.79 1041.47 1311.71 1213.82 1120.57 1191.64C1025.85 1180.65 900.157 1259.36 795.581 1177.73C689.125 1094.62 736.968 909.826 745.03 840.357C761.01 702.646 948.492 553.715 1126.64 574.387Z"
            />
          </path>
          <circle
            cx="1200"
            cy="800"
            r="350"
            fill={variantColors[variant].color2}
            opacity="0.5"
            filter="url(#glow)"
          >
            <animate
              attributeName="r"
              dur="22s"
              repeatCount="indefinite"
              values="350;450;350"
            />
          </circle>
        </g>
      </svg>
    </AnimatedBackground>
  );
};

const AnimatedBackground = styled.div`
  position: absolute;
  top: -40vh;
  ${(props) => !props.$isFooter && `height: 80vh;`}
  width: 2560px;

  z-index: -2;
  pointer-events: none;

  ${(props) =>
    props.$isFooter &&
    `rotate: 180deg;
    left:0;
    top: -10px;`}
`;
